import {PlusIcon} from '@/components/ui/icon/Icon'
import {useTranslation} from '@/translations/i18n'
import {routes} from '@/utilities/constants/routes'
import {generatePath} from 'react-router-dom'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {
    StyledAddRelationButtonLink,
    StyledMedicalRecordHeader
} from '@/features/medical-records/components/medical-record-header/style'
import {MedicalRecordDateRangeFilter} from '@/features/medical-records/components/medical-record-date-range-filter/MedicalRecordDateRangeFilter'
import {MedicalRecordOperatorFilter} from '@/features/medical-records/components/medical-record-operator-filter/MedicalRecordOperatorFilter'
import {MedicalRecordReportTypeFilter} from '@/features/medical-records/components/medical-record-report-type-filter/MedicalRecordReportTypeFilter'
import {MedicalRecordProjectFilter} from '@/features/medical-records/components/medical-record-project-filter/MedicalRecordProjectFilter'
import {usePermissions} from '@/features/auth/store/store'
import {MedicalRecordAggregatedPrintModal} from '../medical-record-aggregated-print-modal/MedicalRecordAggregatedPrintModal'
import {Tooltip} from '@/components/ui/tooltip/Tooltip'

interface MedicalRecordHeaderProps {
    patientId: string
    hasNeuromuscularDiagnosis: boolean
    hasProject: boolean
}

export const MedicalRecordHeader = ({patientId, hasNeuromuscularDiagnosis, hasProject}: MedicalRecordHeaderProps) => {
    const {t} = useTranslation()
    const permissions = usePermissions()
    const canAddReport = hasProject || hasNeuromuscularDiagnosis

    return (
        <StyledMedicalRecordHeader>
            <Flexbox gap={2}>
                <MedicalRecordDateRangeFilter />
                <MedicalRecordOperatorFilter />
                <MedicalRecordReportTypeFilter />
                <MedicalRecordProjectFilter patientId={patientId} />
            </Flexbox>
            {permissions?.medicalRecords.write && (
                <Flexbox gap={2} align="center">
                    <MedicalRecordAggregatedPrintModal patientId={patientId} />
                    <Tooltip
                        content={t('medical_records:add_report_disabled_missing_diagnosis')}
                        triggerProps={{asChild: true}}
                        rootProps={{open: canAddReport ? false : undefined}}
                        variant="light"
                        maxWidth={300}
                    >
                        <StyledAddRelationButtonLink
                            variant="primaryNeutral"
                            to={generatePath(routes.CREATE_MEDICAL_REPORT.path, {id: patientId})}
                            disabled={!canAddReport}
                        >
                            <PlusIcon />
                            {t('commons:report', {count: 1})}
                        </StyledAddRelationButtonLink>
                    </Tooltip>
                </Flexbox>
            )}
        </StyledMedicalRecordHeader>
    )
}
